module.exports = __webpack_public_path__ + "static/media/greenhouse.5825e027.png";